import { Component, OnInit } from '@angular/core';
import { UserService } from './shared';
import { Router, ActivatedRoute } from '@angular/router';

/**
 * This component really has no view, it just simply routes the user to login or if already logged in, to a different page.
 */
@Component({ template: '' })
export class LoginComponent implements OnInit {
  
  private defaultPage = 'admin/home-ward/students';

  returnUrl = '';

  constructor(
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const baseUrl = document.getElementsByTagName('base')[0].href;

    // already have a / in the appRoot
    this.returnUrl = `${baseUrl}${this.defaultPage}`;

    // check if there's a specific page we really want
    if (this.route.snapshot.queryParams['returnUrl']) {
      this.returnUrl = `${baseUrl}${this.route.snapshot.queryParams['returnUrl']}`;
    }

    // TODO might need to redo the isLoggedIn() to something like isLoggedInByuiAccount() and isLoggedInLdsAccount() or something...
    if (this.userService.isLoggedIn()) {
      this.router.navigate([this.defaultPage]);
    } else {
      window.location.href = `${baseUrl}support/login?redirectUrl=${this.returnUrl}`;
    }
  }
}
